module.exports = __webpack_public_path__ + "img/how_it_works_scopes.65bb0b30.svg";